import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

interface StatTileProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  icon?: ReactNode;
  /** 0..1 fill for the mini bar; omit to hide the bar */
  fill?: number;
  accent?: "ember" | "online" | "warn" | "muted";
  className?: string;
}

const barColor = {
  ember: "bg-ember",
  online: "bg-online",
  warn: "bg-warn",
  muted: "bg-white/25",
};

export const StatTile = ({ label, value, sub, icon, fill, accent = "ember", className }: StatTileProps) => (
  <div className={cn("bg-surface border border-line rounded-xl p-4", className)}>
    <div className="flex items-center gap-2 text-fg-muted">
      {icon}
      <span className="text-[11px] uppercase tracking-wider font-medium">{label}</span>
    </div>
    <div className="mt-1.5 font-mono text-2xl text-fg tracking-tight leading-none">{value}</div>
    {sub && <div className="text-xs text-fg-muted mt-1">{sub}</div>}
    {fill !== undefined && (
      <div className="mt-3 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
        <div
          className={cn("h-full rounded-full transition-all duration-500", barColor[accent])}
          style={{ width: `${Math.min(100, Math.max(0, fill * 100))}%` }}
        />
      </div>
    )}
  </div>
);
